import NativeAccountPage from './NativeAccountPage';

export default function SocialSignupForm() {
  return (
    <NativeAccountPage
      title="Complete Account Setup"
      description="Complete registration for your connected account."
      label="Continue Registration"
      returnHref="/accounts/login/"
      returnLabel="Sign In"
      href="/accounts/3rdparty/signup/"
    />
  );
}
